@if (currentScript) {
  <div class="col mx-0 caller_info row w-100 callscriptcontainer">
    <div class="firstdiv" style="margin-right: 12px;">
      <a [ngClass]="currentScript?.Information ? 'informationicon' : 'speaking'"></a>
    </div>
    <div class="seconddiv" style="margin-top: 2px;">
      <p [innerHTML]="replaceNewlines(currentScript?.Name)"></p>
    </div>
    <div class="thirddiv">
      @if (!facOpsDataService.isFirstScript()) {
        <a class="backicon me-2" style="margin-top: 6px;" (click)="onClickBackward()"></a>
      }
      @if (facOpsDataService.isFirstScript() && isTransactionInitiated()) {
        <div class="w-75 me-2 mt-1">
          <select class="form-select w-100" style="height: 29px;padding-top: 5px;" [(ngModel)]="selectedRoute"
            (change)="onChangeRoute($event)" [disabled]="disableRouteDropDown()">
            @for (rt of routes; track rt) {
              <option [value]="rt.Id">{{rt.Name}}</option>
            }
          </select>
        </div>
      }
      @if (!facOpsDataService.isLastScript()) {
        <a class="nexticon me-2" style="margin-top: 6px;" (click)="onClickForward()"></a>
      }
    </div>
  </div>
}